import { gql } from '@apollo/client';

export const GET_CREDENTIALS_MEMPHIS = gql`
  query GetMemphisCredentials($storeId: ID!) {
    getMemphisCredentials(storeId: $storeId) {
      ... on GetMemphisCredentialsSuccess {
        code
        credentials {
          username
          password
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
